// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCFFMAvFYPg-pIjcXzOCw-WNkqBXwxLlh4",
  authDomain: "landcsape-app.firebaseapp.com",
  projectId: "landcsape-app",
  storageBucket: "landcsape-app.appspot.com",
  messagingSenderId: "841446505267",
  appId: "1:841446505267:web:084a6d447652fbad535c46",
  measurementId: "G-GHJ5PTK38S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export {auth, db};
